/** Supported app locales — must match landing site locales. */
export const APP_LOCALES = ['en', 'pt', 'fr', 'es'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'xph_app_locale';
export const LOCALE_COOKIE_KEY = 'xph_locale';

export const LOCALE_LABELS = {
  en: { native: 'English', english: 'English' },
  pt: { native: 'Português', english: 'Portuguese' },
  fr: { native: 'Français', english: 'French' },
  es: { native: 'Español', english: 'Spanish' },
};

export function normalizeLocale(raw) {
  if (!raw || typeof raw !== 'string') return DEFAULT_LOCALE;
  const base = raw.toLowerCase().split('-')[0];
  return APP_LOCALES.includes(base) ? base : DEFAULT_LOCALE;
}

export function readLocaleCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${LOCALE_COOKIE_KEY}=([^;]*)`));
  return match ? normalizeLocale(decodeURIComponent(match[1])) : null;
}

/** Shared across *.xpherium.com so landing → app → partner inherit locale. */
export function cookieDomainSuffix() {
  if (typeof window === 'undefined') return '';
  try {
    if (/(\.|^)xpherium\.com$/i.test(window.location.hostname)) {
      return ';domain=.xpherium.com';
    }
  } catch { /* ignore */ }
  return '';
}

export function writeLocaleCookie(locale) {
  if (typeof document === 'undefined') return;
  const maxAge = 60 * 60 * 24 * 365;
  document.cookie = `${LOCALE_COOKIE_KEY}=${encodeURIComponent(normalizeLocale(locale))};path=/;max-age=${maxAge};SameSite=Lax${cookieDomainSuffix()}`;
}

/** Append ?lang= for cross-origin handoff (partner.xpherium.com). */
export function appendLocaleToUrl(url, locale) {
  const lng = normalizeLocale(locale);
  if (!lng) return url;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'https://partner.xpherium.com';
    const u = new URL(url, base);
    u.searchParams.set('lang', lng);
    return u.toString();
  } catch {
    return url;
  }
}

export function readLocaleFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('lang') || params.get('locale');
    return raw ? normalizeLocale(raw) : null;
  } catch {
    return null;
  }
}
